'use strict'

const u = require('universalify').fromCallback
module.exports = {
  move: u(require('./move'))
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/~/fs-extra/lib/move/index.js
// module id = 2709
// module chunks = 0 1